import ReactModal from 'react-modal';

// Initialize ReactModal once for the entire application
let isInitialized = false;

export const initializeModals = () => {
  if (!isInitialized) {
    ReactModal.setAppElement('#root');
    isInitialized = true;
  }
};

// Auto-initialize on import
initializeModals();